
import { themeLocalKey } from './storeKey'
// 获取当前样式（布局、主题）
export const getCurrentStyle = () => {
  return JSON.parse(localStorage.getItem(themeLocalKey))
}
// 设置当前样式
export const setCurrentStyle = (item) => {
  localStorage.setItem(themeLocalKey, JSON.stringify(item))
}

// 更新主题样式
export const changeTheme = (themeName) => {
  // 设置HTML标签上data-theme属性的值
  document.documentElement.setAttribute('data-theme', themeName)
  document.documentElement.setAttribute('data-root', window.__POWERED_BY_WUJIE__ ? 'wujie' : 'main')
  // 加载 Element Plus 样式表的 ID
  const themeElId = 'el-plus-theme'
  // 样式表的元素
  const themeEl = document.getElementById(themeElId)
  // 对应的样式表文件，存放在public中，不被打包
  // const path = `${window.__POWERED_BY_QIANKUN__ ? window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ : process.env.VUE_APP_CONTEXT}themes/${themeName}.css`
  const path = `themes/${themeName}.css`//切换主题需要修改的css路径
  if (!themeEl) {
    const head = document.head || document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.id = themeElId
    link.href = path
    head.appendChild(link)
  } else {
    themeEl.href = path
  }
}
